export const searchConstants = { 
    SET_SEARCH_RESULTS: 'SET_SEARCH_RESULTS',

    SET_SEARCH_QUERIES: 'SET_SEARCH_QUERIES',

    SET_RESULTS_MSG: 'SET_RESULTS_MSG',

    SET_HAS_CONVERSATIONAL: 'SET_HAS_CONVERSATIONAL'
}